import { render, staticRenderFns } from "./selectOrigin.vue?vue&type=template&id=04d4f8f4&scoped=true&"
import script from "./selectOrigin.vue?vue&type=script&lang=js&"
export * from "./selectOrigin.vue?vue&type=script&lang=js&"
import style0 from "./occurrence.css?vue&type=style&index=0&id=04d4f8f4&prod&scoped=true&lang=css&"
import style1 from "./selectOrigin.vue?vue&type=style&index=1&id=04d4f8f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4f8f4",
  null
  
)

export default component.exports